(() => {
    const GLOBAL_INIT_KEY = '__s1_2wd_media_text_registered__';
    if (window[GLOBAL_INIT_KEY]) return;
    window[GLOBAL_INIT_KEY] = true;

class S12wdMediaTextSection extends HTMLElement {
    connectedCallback() {
        this.initPlyrWithRetry();
    }

    initPlyrWithRetry() {
        let attempts = 0;
        const maxAttempts = 20;
        const intervalMs = 200;

        const timer = window.setInterval(() => {
            attempts += 1;
            if (this.initPlyrPlayers() || attempts >= maxAttempts) {
                window.clearInterval(timer);
            }
        }, intervalMs);
    }

    initPlyrPlayers() {
        if (!window.Plyr) return false;

        const playerNodes = this.querySelectorAll('.s1-2wd-media-text-plyr');
        if (!playerNodes.length) return true;

        playerNodes.forEach((node) => {
            if (node.dataset.plyrInited === 'true') return;

            const player = new Plyr(node, {
                muted: true,
                autoplay: true,
                controls: [],
                loop: { active: true },
                playsinline: true,
                youtube: {
                    autoplay: 1,
                    mute: 1,
                    rel: 0,
                    showinfo: 0,
                    controls: 0
                },
                // Quality settings from reference
                quality: {
                    default: 1080,
                    options: [4320, 2880, 2160, 1440, 1080, 720, 576, 480, 360, 240]
                }
            });

            player.on('ready', () => {
                player.muted = true;
                player.play();
            });

            node.dataset.plyrInited = 'true';
        });

        return true;
    }
}

if (!customElements.get('s1-2wd-media-text-section')) {
    customElements.define('s1-2wd-media-text-section', S12wdMediaTextSection);
}

class S12wdMediaTextContentItemContentCompare extends HTMLElement {
    connectedCallback() {
        this.initAnimation();
    }

    initAnimation() {
        // Avoid double init if the component is re-connected.
        if (this.dataset.compareInited === 'true') return;
        this.dataset.compareInited = 'true';

        const compareItems = this.querySelectorAll(
            '.s1-2wd-media-text-content-item-content-compare-item'
        );
        if (!compareItems.length) return;

        compareItems.forEach((item) => {
            const target = (item.style.getPropertyValue('--compare-percentage') || '').trim();
            if (!target) return;

            // Keep target for later reset
            item.dataset.comparePercentageTarget = target;

            // Start at 0% (per requirement)
            item.style.setProperty('--compare-percentage', '0%');

            // Animate width change when CSS var updates
            const bar = item.querySelector(
                '.s1-2wd-media-text-content-item-content-compare-item__bottom__percentage__bar'
            );
            if (bar) {
                bar.style.transition = 'width 0.8s ease';
                bar.style.willChange = 'width';
            }
        });

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (!(entry.target instanceof HTMLElement)) return;

                    const item = entry.target;
                    const target = item.dataset.comparePercentageTarget || '';
                    if (!target) return;

                    const next = entry.isIntersecting ? target : '0%';
                    if (item.style.getPropertyValue('--compare-percentage') !== next) {
                        item.style.setProperty('--compare-percentage', next);
                    }
                });
            },
            {
                // Trigger when the item starts to enter/leaves viewport
                threshold: 0.2,
                rootMargin: '0px 0px -20% 0px'
            }
        );

        compareItems.forEach((item) => observer.observe(item));
    }
}

if (!customElements.get('s1-2wd-media-text-content-item-content-compare')) {
    customElements.define('s1-2wd-media-text-content-item-content-compare', S12wdMediaTextContentItemContentCompare);
}

class S12wdMediaTextContentItemContentSlider extends HTMLElement {
    connectedCallback() {
        this.initSwiperWithRetry();
    }

    disconnectedCallback() {
        if (Array.isArray(this.swiperInstances)) {
            this.swiperInstances.forEach((instance) => {
                if (instance && typeof instance.destroy === 'function') {
                    instance.destroy(true, true);
                }
            });
            this.swiperInstances = [];
        }
    }

    initSwiperWithRetry() {
        let attempts = 0;
        const maxAttempts = 20;
        const intervalMs = 200;

        const timer = window.setInterval(() => {
            attempts += 1;
            if (this.initSwipers() || attempts >= maxAttempts) {
                window.clearInterval(timer);
            }
        }, intervalMs);
    }

    initSwipers() {
        if (this.dataset.sliderInited === 'true') return;
        if (!window.Swiper) return false;

        const sliderNodes = this.querySelectorAll('.s1-2wd-media-text-content-item-content-slider-items.swiper');
        if (!sliderNodes.length) return true;

        this.swiperInstances = [];

        const spaceBetweenMobilePx = () => Math.round((window.innerWidth * 2.666667) / 100);

        sliderNodes.forEach((node) => {
            const instance = new window.Swiper(node, {
                direction: 'horizontal',
                loop: true,
                slidesPerView: 'auto',
                spaceBetween: spaceBetweenMobilePx(),
                breakpoints: {
                    750: {
                        spaceBetween: 20
                    }
                },
                allowTouchMove: false,
                freeMode: {
                    enabled: false,
                    momentum: false
                },
                speed: 1000,
                autoplay: {
                    delay: 1000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: false
                }
            });

            this.swiperInstances.push(instance);
        });

        this.dataset.sliderInited = 'true';
        return true;
    }
}

if (!customElements.get('s1-2wd-media-text-content-item-content-slider')) {
    customElements.define('s1-2wd-media-text-content-item-content-slider', S12wdMediaTextContentItemContentSlider);
}
})();
